import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface User {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  isTwoFactorEnabled: boolean;
  isAdmin: boolean;
  job: string;
  profile_picture: string | null;
   google_calendar_enabled?: boolean;
  outlook_calendar_enabled?: boolean;
  time_zone?: string;
  date_format?: string;
  password_changed_at?: Date;
}

interface CommunityUser {
  id: number;
  name: string;
  email: string;
  avatar: string | null;
  bio?: string;
  department?: string | "";
  job_title?: string | "";
  skills?: string[];
}

interface AuthContextType {
  user: User | null;
  loading: boolean;
  error: string | null;
  login: (email: string, password: string, twoFactorToken?: string, rememberMe?: boolean) => Promise<void>;
  logout: () => void;
  register: (userData: RegisterData) => Promise<void>;
  verifyOTP: (email: string, otp: string) => Promise<void>;
  clearError: () => void;
  token: string | null;
  resendOTP: (email: string, isNew: boolean) => Promise<void>;
  forgotPassword: (email: string) => Promise<void>;
  resetPassword: (token: string,newPassword: string) => Promise<void>;
  setupTwoFactor: () => Promise<{ secret: string, qrCodeDataURL: string }>;
  verifyAndEnableTwoFactor: (token: string) => Promise<void>;
  verifyTwoFactorToken: (email: string, password: string, token: string) => Promise<void>;
  disableTwoFactor: (token: string) => Promise<void>;
  myProfile: () => Promise<User>;
  updateProfile: (updates: any) => Promise<User>;
  uploadProfileImage: (formData: FormData) => Promise<{ message: string; imageUrl: string }>;
  changePassword: (oldPassword: string, newPassword: string) => Promise<void>;
  connectGoogleCalendar: () => Promise<string>;
  connectOutlookCalendar: () => Promise<string>;
  disconnectGoogleCalendar: () => Promise<void>;
  disconnectOutlookCalendar: () => Promise<void>;
  refreshUser: () => Promise<void>;
  searchUsers: (query?: string) => Promise<Array<{id: number, name: string, email: string, avatar: string | null}>>;
  getAllCommunityUsers: () => Promise<User[]>;
  communityUsers: CommunityUser[];
}

interface RegisterData {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
 const [user, setUser] = useState<User | null>(localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') as string) : sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user') as string) : null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [token, setToken] = useState<string | null>(localStorage.getItem('token') || sessionStorage.getItem('token'));
  const [communityUsers, setCommunityUsers] = useState<CommunityUser[]>([]);
  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'https://vela-back.wingtrill.com';
  console.log("Backend URL:", backendUrl);

  console.log("User:", user);
  console.log("isAdmin:", user?.isAdmin);
  
  useEffect(() => {
      if(token){
        getAllCommunityUsers()
      }
    }, [user]);
  

  const clearError = () => setError(null);

  const searchUsers = async (query?: string) => {
    setLoading(true);
    clearError();
    
    try {
      const url = query 
        ? `${backendUrl}/api/auth/search-users?query=${encodeURIComponent(query)}` 
        : `${backendUrl}/api/auth/search-users`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to search users');
      }

      setLoading(false);
      return data.users;
    } catch (err: any) {
      setLoading(false);
      setError(err.message || 'An error occurred while searching users');
      return [];
    }
  };

// const login = async (email: string, password: string) => {
//   setLoading(true);
//   clearError();
  
//   try {
//     const response = await fetch(`${backendUrl}/api/auth/login`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({ email, password }),
//     });

//     const data = await response.json();

//     if (!response.ok) {
//       // Check if email verification is required
//       if (data.requiresVerification) {
//         const error: any = new Error(data.message || 'Email not verified');
//         error.requiresVerification = true; // Add the flag to the error object
//         throw error;
//       }
      
//       throw new Error(data.message || 'Login failed');
//     }

//     setUser(data.user);
//     console.log("Login successful, user data:", data.user);
//     localStorage.setItem('user', JSON.stringify(data.user));
    
//     setToken(data.token);
//     // Store token in localStorage
//     localStorage.setItem('token', data.token);
//     console.log("Login successful, token stored.", data.token);
//     console.log("User data:", data.user);
//     console.log("Response data:", localStorage.getItem('token'));
    
//   } catch (err: any) {
//     setError(err.message);
//     throw err; // Re-throw to handle in Login component
//   } finally {
//     setLoading(false);
//   }
// };


// const login = async (email: string, password: string, twoFactorToken?: string, rememberMe?: boolean) => {
//   setLoading(true);
//   clearError();
  
//   try {
//     const response = await fetch(`${backendUrl}/api/auth/login`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({ 
//         email, 
//         password,
//         twoFactorToken // Include the 2FA token if provided
//       }),
//     });

//     const data = await response.json();  

//     if (!response.ok) {
//       if (data.requires2FA) {
//         const error: any = new Error(data.message);
//         error.requires2FA = true;
//         throw error;
//       } else if (data.requiresVerification) {
//         const error: any = new Error(data.message);
//         error.requiresVerification = true;
//         throw error;
//       } else if (data.requiresPasswordChange) {
// setUser(data.user);
// setToken(data.token);

// const storage = rememberMe ? localStorage : sessionStorage;

// storage.setItem('user', JSON.stringify(data.user));
// storage.setItem('token', data.token);

//   const error: any = new Error(data.message);
//   error.requiresPasswordChange = true;
//   throw error;
// }

// else if (data.requiresTwoFactorSetup) {
//   setUser(data.user);               // 👈 add this
//   localStorage.setItem('user', JSON.stringify(data.user));

//   localStorage.setItem('force_2fa_setup', 'true');
  
//   const error: any = new Error(data.message);
//   error.requiresTwoFactorSetup = true;
//   throw error;
// }
//       throw new Error(data.message);
//     }

//     setUser(data.user);
//     setToken(data.token);
//     localStorage.setItem('user', JSON.stringify(data.user));
//     localStorage.setItem('token', data.token);
    
//   } catch (err: any) {
//     setError(err.message);
//     throw err;
//   } finally {
//     setLoading(false);
//   }
// };


const login = async (
  email: string,
  password: string,
  twoFactorToken?: string,
   rememberMe?: boolean,
) => {
  setLoading(true);
  clearError();

  try {
    const response = await fetch(`${backendUrl}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        password,
        // rememberMe,
        twoFactorToken
      }),
    });

    const data = await response.json();
    const storage = rememberMe ? localStorage : sessionStorage;

    if (!response.ok) {
      if (data.requires2FA) {
        const error: any = new Error(data.message);
        error.requires2FA = true;
        throw error;
      }

      if (data.requiresVerification) {
        const error: any = new Error(data.message);
        error.requiresVerification = true;
        throw error;
      }

      if (data.requiresPasswordChange) {
        setUser(data.user);
        storage.setItem('user', JSON.stringify(data.user));
        storage.setItem('force_password_change', 'true');

        const error: any = new Error(data.message);
        error.requiresPasswordChange = true;
        throw error;
      }

      if (data.requiresTwoFactorSetup) {
        setUser(data.user);
        storage.setItem('user', JSON.stringify(data.user));
        storage.setItem('force_2fa_setup', 'true');

        const error: any = new Error(data.message);
        error.requiresTwoFactorSetup = true;
        throw error;
      }

      throw new Error(data.message);
    }

    // Successful login
    setUser(data.user);
    setToken(data.token);

    storage.setItem('user', JSON.stringify(data.user));
    storage.setItem('token', data.token);

  } catch (err: any) {
    setError(err.message);
    throw err;
  } finally {
    setLoading(false);
  }
};



  const register = async (userData: RegisterData) => {
    setLoading(true);
    clearError();

    try {
      const response = await fetch(`${backendUrl}/api/auth/initiate-signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Registration failed');
      }

      return data;
      
    } catch (err: any) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const verifyOTP = async (email: string, otp: string) => {
    setLoading(true);
    clearError();

    try {
      const response = await fetch(`${backendUrl}/api/auth/verify-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, otp }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'OTP verification failed');
      }

      return data;
      
    } catch (err: any) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const resendOTP = async (email: string, isVerification = false) => {
  setLoading(true);
  clearError();

  try {
    const response = await fetch(`${backendUrl}/api/auth/resend-otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, isVerification }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to resend OTP');
    }

    return data;
  } catch (err: any) {
    setError(err.message);
    throw err;
  } finally {
    setLoading(false);
  }
};
  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('darkMode')
    localStorage.removeItem('force_password_change');
    localStorage.removeItem('force_2fa_setup');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('token');
  };

  const forgotPassword = async (email: string) => {
    setLoading(true);
    clearError();
    
    try {
      const response = await fetch(`${backendUrl}/api/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to send reset email');
      }

      return data;
    } catch (err: any) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const resetPassword = async (token: string, newPassword: string) => {
    setLoading(true);
    clearError();
    
    try {
      const response = await fetch(`${backendUrl}/api/auth/reset-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({newPassword, token }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to reset password');
      }

      return data;
    } catch (err: any) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };


  const setupTwoFactor = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/auth/generate-2fa`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId: user?.id }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message);
      return data;
    } catch (err: any) {
      setError(err.message);
      throw err;
    }
  };

  const verifyAndEnableTwoFactor = async (verificationToken: string) => {
    try {
      const response = await fetch(`${backendUrl}/api/auth/verify-2fa`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          userId: user?.id,
          token: verificationToken 
        }),
      });
      console.log("body---",JSON.stringify({ 
        userId: user?.id,
        token: verificationToken 
      }));
      

      const data = await response.json();
      if (!response.ok) throw new Error(data.message);
      return data;
    } catch (err: any) {
      setError(err.message);
      throw err;
    }
  };

  const disableTwoFactor = async (token: string) => {
    try {
      const response = await fetch(`${backendUrl}/api/auth/disable-2fa`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token') || sessionStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          userId: user?.id,
          token 
        }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message);

      // Update user in state and localStorage
      setUser(data.user);
      localStorage.setItem('user', JSON.stringify(data.user));
      
      return data;
    } catch (err: any) {
      setError(err.message);
      throw err;
    }
  };
  const verifyTwoFactorToken = async (email: string, password: string, twoFactorToken: string) => {
  try {
    await login(email, password, twoFactorToken);
  } catch (err: any) {
    setError(err.message);
    throw err;
  }
};


const refreshUser = async () => {
  try {
    const response = await fetch(`${backendUrl}/api/auth/my-profile`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: user?.id }),
    });
    const data = await response.json();
    if (!response.ok) return;
    setUser(data);
    const storage = localStorage.getItem('token') ? localStorage : sessionStorage;
    storage.setItem('user', JSON.stringify(data));
  } catch {}
};

const myProfile =async () => {
  try {
    const response = await fetch(`${backendUrl}/api/auth/my-profile`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId: user?.id }),
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.message);
    return data;
  } catch (err: any) {
    setError(err.message);
    throw err;
  }
};

const updateProfile = async (updates: any) => {
  try {
    const response = await fetch(`${backendUrl}/api/auth/update-profile`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId: user?.id, updates }),
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.message);
    return data;
  } catch (err: any) {
    setError(err.message);
    throw err;
  }
};


const uploadProfileImage = async (formData: FormData) => {
  try {
    const response = await fetch(`${backendUrl}/api/auth/upload-profile-image`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      body: formData,
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.message);
    // Optimistically update profile_picture in state for instant UI feedback
    if (user) setUser({ ...user, profile_picture: data.imageUrl });
    // Then sync full user from backend (single source of truth)
    await refreshUser();
    return data;
  } catch (err: any) {
    setError(err.message);
    throw err;
  }
};


const changePassword = async (oldPassword: string, newPassword: string) => {
  try {
    const response = await fetch(`${backendUrl}/api/auth/change-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        userId: user?.id,
        oldPassword,
        newPassword,
      }),
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.message);

    alert("Password updated successfully!");
  } catch (err: any) {
    alert(err.message);
  }
};


const connectGoogleCalendar = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/auth/google/auth-url`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to get Google auth URL');
      }

      const data = await response.json();
      window.location.href = data.url;
      return data.url;
    } catch (error) {
      console.error('Error connecting to Google Calendar:', error);
      throw error;
    }
  };

  const connectOutlookCalendar = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/auth/outlook/auth-url`, {
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
      });
      if (!response.ok) throw new Error('Failed to get Outlook auth URL');
      const data = await response.json();
      window.location.href = data.url;
      return data.url;
    } catch (error) {
      console.error('Error connecting to Outlook Calendar:', error);
      throw error;
    }
  };

  const disconnectGoogleCalendar = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/auth/google/disconnect`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      if (!response.ok) throw new Error('Failed to disconnect Google Calendar');
      await refreshUser();
    } catch (error) {
      console.error('Error disconnecting Google Calendar:', error);
      throw error;
    }
  };

  const disconnectOutlookCalendar = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/auth/outlook/disconnect`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      if (!response.ok) throw new Error('Failed to disconnect Outlook Calendar');
      await refreshUser();
    } catch (error) {
      console.error('Error disconnecting Outlook Calendar:', error);
      throw error;
    }
  };


  const getAllCommunityUsers = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/auth/community/users`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to get community users');
      }

      const data = await response.json();
      console.log("data from api:", data);
      
      setCommunityUsers(data.users);
      console.log("communityUsers:", communityUsers);
      
      return data.users;
    } catch (error) {
      console.error('Error fetching community users:', error);
      throw error;
    }
  };




  return (
    <AuthContext.Provider 
      value={{ 
        user, 
        loading, 
        error,
        token,
        login, 
        logout, 
        register, 
        verifyOTP,
        clearError,
        resendOTP,
        forgotPassword,
        resetPassword,
        setupTwoFactor,
        verifyAndEnableTwoFactor,
        verifyTwoFactorToken,
        disableTwoFactor,
        myProfile,
        updateProfile,
        uploadProfileImage,
        changePassword,
         connectGoogleCalendar,
        connectOutlookCalendar,
        disconnectGoogleCalendar,
        disconnectOutlookCalendar,
        refreshUser,
        searchUsers,
        getAllCommunityUsers,
        communityUsers,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};